import { lazy } from 'react';
import { IRouteProps } from 'src/modules';

export const route = '/join-wait-list';

const WaitListRoute: IRouteProps = {
    path: route,
    exact: true,
    component: lazy(() => import('src/modules/WaitList')),
    name: 'WaitList',
};

export default WaitListRoute;
